import React, { createContext, useState, useContext } from "react";

const FontSizeContext = createContext();

export const useFontSize = () => useContext(FontSizeContext);

export const FontSizeProvider = ({ children }) => {
  const [fontSizeMultiplier, setFontSizeMultiplier] = useState(1);

  const step = 0.025;   
  const min = 0.9;     
  const max = 1.2;      

  const increaseFont = () => {
    setFontSizeMultiplier(prev => Math.min(prev + step, max));
  };

  const decreaseFont = () => {
    setFontSizeMultiplier(prev => Math.max(prev - step, min));
  };

  const resetFont = () => setFontSizeMultiplier(1);

  return (
    <FontSizeContext.Provider
      value={{ fontSizeMultiplier, increaseFont, decreaseFont, resetFont }}
    >
      {children}
    </FontSizeContext.Provider>
  );
};
